const styles = {
    menuContainer: {
        display: 'inline-block',
    },
    menuShareButtonContainer: {
        textAlign: 'right',
    },
    button: {
        // Default css to stop the icons from looking like buttons
        backgroundColor: 'transparent',
        backgroundRepeat: 'no-repeat',
        border: 'none',
        cursor: 'pointer',
        overflow: 'hidden',
        outline: 'none',
        '&:focus': {
            outline: 'none',
        },
    },
    menuShareButton: {
        fontSize: 16,
        borderRadius: 6.4,
        padding: 4,
        height: 32,
        width: 32,
        boxShadow: '0 2px 3px 0 rgba(0,0,0,0.2)',
        '& path:nth-child(2)': {
            fill: props => (props.svgColor ? props.svgColor : '#6373A4'),
        },

        '&:hover': {
            '& path:nth-child(2)': {
                fill: props => (!props.svgColor ? '#051D39' : ''),
            },
        },
    },
    showMenu: {
        display: 'block',
    },
    hideMenu: {
        display: 'none',
    },
    menu: {
        position: 'absolute',
        minWidth: '80px',
        right: '0px',
        backgroundColor: '#FFFFFF',
        bottom: '40px',
        zIndex: 4000,
        borderRadius: '8px',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
    },
    menuButtonIcons: {
        padding: 8,
        '&:hover': {
            '& path': {
                fill: '#051D39',
            },
        },
    },

    iconRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        height: 40,
    },
    iconCol: {
        width: '50%',
    },

    twitterXIcon: {
        transform: 'scale(0.75)',
    },
}
export default styles
